
export const DEFAULT_FULL_TANK_QUANTITY = 300000
export const DEFAULT_NOT_FULL_TANK_QUANTITY = 110000
export const DEFAULT_PCS = 15.25